'use client';

import { useMemo } from 'react';
import { useEdgeConfig } from '@/hooks/useEdgeConfig';
import { EDGE_CONFIG_KEYS } from '@/lib/edge-config/constants';
import ConditionalNavbar from './ConditionalNavbar';

/**
 * Client component that fetches banner configuration from Edge Config
 * and provides it to ConditionalNavbar.
 * 
 * This allows the root layout to be statically generated while still
 * supporting dynamic banner configuration.
 */
export default function BannerConfigProvider() {
    const [config, isLoading] = useEdgeConfig([
        EDGE_CONFIG_KEYS.TOP_BANNER_DISPLAY,
        EDGE_CONFIG_KEYS.TOP_BANNER_TEXT,
        EDGE_CONFIG_KEYS.TOP_BANNER_CTA_TEXT,
        EDGE_CONFIG_KEYS.TOP_BANNER_CTA,
    ]);

    // Transform config into banner data format
    const bannerData = useMemo(() => {
        if (isLoading) return null;

        return {
            bannerConfig: config[EDGE_CONFIG_KEYS.TOP_BANNER_DISPLAY] || null,
            bannerText: config[EDGE_CONFIG_KEYS.TOP_BANNER_TEXT] || null,
            bannerCtaText: config[EDGE_CONFIG_KEYS.TOP_BANNER_CTA_TEXT] || null,
            bannerCta: config[EDGE_CONFIG_KEYS.TOP_BANNER_CTA] || null,
        };
    }, [config, isLoading]);

    // Render navbar immediately (it will show banner only if config is available)
    return <ConditionalNavbar bannerData={bannerData} />;
}
